import styled from 'styled-components';
import { ModalBody } from 'reactstrap';
import { Button } from '@shoflo/polymer';
import { StyledModalHeader } from '@shoflo/polymer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
`;

export const StyledBodyText = styled.p`
  color: #6e7582;
`;

export const StyledCancelButton = styled(Button)`
  border: 1px solid #dfe3ec;
  box-sizing: border-box;
  margin-left: 16px;
`;

export const ModalHeader = styled(StyledModalHeader)`
  h5 {
    font-size: 28px !important;
    color: #33373d !important;
  }
`;

export const StyledErrorWrapper = styled.div`
  background: #ffea7f;
  border: 2px solid #735c0f;
  box-sizing: border-box;
  border-radius: 4px;
  margin-bottom: 24px;
  padding: 12px;
`;

export const StyledErrorHeader = styled.div`
  display: flex;
`;

export const StyledErrorHeaderIconWrapper = styled.div``;

export const StyledErrorHeaderIcon = styled(FontAwesomeIcon)`
  color: #735c0f;
  margin-right: 10px;
  width: 16px;
  height: 16px;
`;

export const StyledErrorHeaderText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #735c0f;
`;

export const StyledErrorBodyText = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #735c0f;
  margin-top: 15px;
`;

export const StyledErrorTipText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #735c0f;
  margin-top: 15px;
`;
